export class AlertType {
    id: number;
    name: string;
}